import * as React from 'react';
import propz from 'propz';
import { FunctionComponent } from 'react';
import classNames from 'classnames';

interface Props {
  onCloseClick: () => void;
  onAcceptClick: () => void;
  isOpen: boolean;
  request: any;
  mergeUser: any;
}

export const AcceptAndMergeRequestInfoModal: FunctionComponent<Props> = props => {
  if (!props.isOpen) {
    return null;
  }

  const modalClasses = classNames({
    mDisplayBlock: props.isOpen,
    show: props.isOpen,
    modal: true,
    fade: true
  });

  const request = props.request;
  const mergeUser = props.mergeUser;
  const requesterFirstName = propz.get(request, ['requester', 'firstName'], '');
  const requesterLastName = propz.get(request, ['requester', 'lastName'], '');
  const mergeUserFirstName = propz.get(mergeUser, ['user', 'firstName'], '');
  const mergeUserLastName = propz.get(mergeUser, ['user', 'lastName'], '');
  const mergeUserDOB = propz.get(mergeUser, ['user', 'birthday'], '');

  return (
    <div className={modalClasses}>
      <div className="modal-dialog modal-md requestActionModal__dialog">
        <div className="modal-content requestActionModal">
          <div className="requestActionModal__head">
            <div className="requestActionModal__icon">M</div>
            <div>
              <h5>Confirm merge</h5>
              <p>This will merge the role request into an existing user record.</p>
            </div>
            <button type="button" className="requestActionModal__close" onClick={props.onCloseClick} aria-label="Close">
              <span>&times;</span>
            </button>
          </div>

          <div className="requestActionModal__body">
            <div className="requestActionModal__summaryCard">
              <span>Existing user</span>
              <strong>
                {mergeUserFirstName} {mergeUserLastName}
              </strong>
              {mergeUserDOB ? <small>{mergeUserDOB}</small> : null}
            </div>
            <div className="requestActionModal__summaryArrow">will be merged with</div>
            <div className="requestActionModal__summaryCard">
              <span>Requested role for</span>
              <strong>
                {requesterFirstName} {requesterLastName}
              </strong>
            </div>
          </div>

          <div className="requestActionModal__foot">
            <button type="button" className="people-btn people-btn--secondary" onClick={props.onCloseClick}>
              Cancel
            </button>
            <button type="button" className="people-btn people-btn--primary" onClick={props.onAcceptClick}>
              Confirm merge
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

AcceptAndMergeRequestInfoModal.displayName = 'AcceptAndMergeRequestInfoModal';
